module.exports = __webpack_public_path__ + "img/marker-icon-qxpzyj.813f4cae.png";